import React, {Component} from "react";
import {connect} from "react-redux";
import {popupHide, popupShow} from "../../../libs/redux/actions/popup";
import {rd, route, routes, type_channel, type_popup} from "../../../vars/rd";
import {$shutils} from "../../../libs/snnh/snnh";
import CategoryBusiness from "../buttons/category.business";
import {jsi} from "../../../index";
import ChannelFavorite from "../buttons/channel.favorite";
import {recentChannelChange} from "../../../libs/redux/actions/recent.channel";


class ChannelItem extends Component {
    constructor(props) {
        super(props);

        this.themeChange = props.themeCallback;

        this.last = props.last || false;

        this.type = props.type;
        if(!this.type) this.type = type_channel.default;
        this.index = props.index;

        /**
         * @type {{ data: DaoChannel, popup: boolean }}
         */
        this.state = {
            data: props.data || {},
            popup: props.hasOwnProperty('popup') ? props.popup : true
        };
    }

    componentDidUpdate(prevProps, prevState) {
        try {
            if([type_channel.player].indexOf(this.props.type) >= 0) {
                /** @type {DaoPlayerChannel} */
                const n_channel = this.props.data;
                /** @type {DaoPlayerChannel} */
                const p_channel = prevProps.data;
                if(p_channel.channelid !== n_channel.channelid) {
                    this.setState(p_state => {
                        /** @type {DaoPlayerChannel} */
                        const data = p_state.data;
                        Object.keys(n_channel).forEach((key) => {
                            if(data.hasOwnProperty(key)) {
                                data[key] = n_channel[key];
                            }
                        });
                        return  {data};
                    })
                }
            }
        } catch (e) {}
    }

    get dispatch() {
        return this.props.hasOwnProperty('dispatch') ? this.props.dispatch : () => {};
    }

    /**
     * @returns {DaoChannel}
     */
    get data() {
        return this.state.data;
    }

    /**
     * 아이템 클릭
     * @param e
     */
    clicked(e) {
        if(this.state.popup) this.dispatch(popupShow(type_popup.channel, this.state.data, null));
        else this.play(e);
        $shutils.ignoreEvents(e);
    }

    /**
     * 재생
     * @param e
     */
    play(e) {
        e.stopPropagation();

        try {
            jsi.jsi_change_channel(
                $shutils.base64Encode(this.data.channelid),
                $shutils.base64Encode(this.data.view_title)
            );
            if(rd.main) {
                rd.main.addHistory(this.data);
            }
            this.dispatch(recentChannelChange(this.data));
        } catch (e) {}
    }

    favoriteCallback(selected) {
        if(this.data) {
            this.data.favorite = selected ? 'Y' : 'N';
        }
    }

    title(replacer=' ') {
        try {
            return this.data.title.replace(rd.linebreak, replacer);
        } catch (e) {}
        return null;
    }

    get genre() {
        return this.data.genreCategory;
    }

    get tempo() {
        return this.data.tempoCategory;
    }

    get theme() {
        return this.data.themeCategory;
    }

    get themeClass() {
        const theme = this.theme;
        return theme ? theme.class : 'orange';
    }

    get themeColor() {
        const theme = this.theme;
        return theme ? theme.color : '#FB754C';
    }

    get themeName() {
        const theme = this.theme;
        return theme ? theme.proname : '#FB754C';
    }

    get themeBackground() {
        return `/images/bg-${this.themeClass}.png`;
    }

    themeClicked(e, theme) {
        if(e) e.stopPropagation()
        if(theme) {
            this.closePopup();
            if(this.themeChange) this.themeChange.call(null, [this.theme.proid.toString()]);
            else route(routes.search_theme, this.theme.proid);
        }
    }

    get business() {
        return this.data.businessCategory;
    }

    /**
     * 추천업종 클릭
     * @param business {DaoCategory}
     */
    businessClicked(business) {
        this.closePopup();
        route(routes.search_business, business.proid);
    }

    closePopup() {
        if(this.dispatch) {
            this.dispatch(popupHide());
        }
    }

    error(e) {
        if (e) {
            e.target.onerror = null;
            e.target.src = "/images/img-rhymeduck-w.png";
        }
    }

    render() {
        const title = this.title();
        const title_lined = this.title('<br />');
        switch (this.type) {
            // 최근 재생한 채널
            case type_channel.recent:
                return (
                    <div className="item" onClick={e => this.play(e)}>
                        <div className="image-wrap">
                            <div className="thumbnail"><img src={this.data.imageProxy} alt={''} onError={this.error} /></div>
                            <div className="title-box">
                                <div className="bg"><img src={this.themeBackground} alt={this.themeName} /></div>
                            </div>
                            <div className="btn-wrap" onClick={e => this.play(e)}>
                                <img src="/images/btn-play.png" alt={'재생'} />
                            </div>
                        </div>
                        <div className="title">{title}</div>
                    </div>
                );

            // 추천채널
            case type_channel.recommand:
                return (
                    <div className="item">
                        <div className="bg-wrap">
                            <div className="bg">
                                <img src={this.data.imageProxy} alt={''} onError={this.error}/>
                                <div className="overlay"></div>
                            </div>
                            <div className="text-box">
                            <div className="text">{(this.data.headline || '').replace(/{업종}/g, (rd.user.shopBusinessName || rd.user.shopName))}</div>
                                <div className="btn-wrap">
                                    <ChannelFavorite type={this.type}
                                                     id={this.data.channelid}
                                                     selected={this.data.isFavorite}
                                                     callback={this.favoriteCallback.bind(this)} />
                                    <span onClick={e => this.play(e)}><img src="/images/icon-play-type2.png" alt={'재생'} /></span>
                                </div>
                            </div>
                        </div>
                        <div className="thumbnail-wrap" onClick={e => this.clicked(e)}>
                            { this.data.isNew ? <span className="new">NEW</span> : null }
                            <div className="image-wrap">
                                <div className="thumbnail"><img src={this.data.imageProxy} alt={''} onError={this.error}/></div>
                                <div className="title-box">
                                    <div className="title" dangerouslySetInnerHTML={{__html: title_lined}}></div>
                                    <div className="bg"><img src={this.themeBackground} alt={this.themeName} /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                );

            // 실시간 인기차트
            case type_channel.chart:
                return (
                    <div className="list-box" onClick={e => this.clicked(e)}>
                        <div className="image-wrap">
                            <div className="num">{this.index || '-'}</div>
                            <div className="thumbnail"><img src={this.data.imageProxy} alt={title} onError={this.error}/></div>
                            <div className="title-box">
                                <div className="bg small"><img src={this.themeBackground} alt={this.themeName}/></div>
                            </div>
                        </div>
                        <div className={`item ${this.last ? 'bd-none' : null}`}>
                            <div className="title">{title}</div>
                            <div className="btn-wrap" onClick={e => this.play(e)}>
                                <img src="/images/btn-play-w.png" alt={'재생'}/>
                            </div>
                        </div>
                    </div>
                );

            // 실시간 인기차트 비즈
            case type_channel.chart_biz:
                return (
                    <div className="list-box" onClick={e => this.clicked(e)}>
                        <div className="image-wrap">
                            <div className="num">{this.index || '-'}</div>
                            <div className="thumbnail"><img src={this.data.imageProxy} alt={title} onError={this.error}/></div>
                            <div className="title-box">
                                <div className="bg small"><img src={this.themeBackground} alt={this.themeName}/></div>
                            </div>
                        </div>
                        <div className={`item ${this.last ? 'bd-none' : null}`}>
                            <div className="title">{title}</div>
                            <div className="btn-wrap" onClick={e => this.play(e)}>
                                <img src="/images/btn-play-b.png" alt={'재생'}/>
                            </div>
                        </div>
                    </div>
                );

            // PD Pick
            case type_channel.pd_pick:
                return (
                    <div className="item">
                        <div className="title-wrap">
                            <div className="title"
                                 dangerouslySetInnerHTML={{__html: $shutils.nl2br(this.data.headline || '찬 공기가 느껴지면\n따뜻한 멜로디로\n가을 감성 채워요')}}>
                            </div>
                        </div>
                        <div className="image-wrap" onClick={e => this.clicked(e)}>
                            <div className="thumbnail"><img src={this.data.imageProxy} alt={''} onError={this.error}/></div>
                            <div className="title-box">
                                <div className="title" dangerouslySetInnerHTML={{__html: title_lined}}></div>
                                <div className="bg"><img src={this.themeBackground} alt={this.themeName}/></div>
                            </div>
                            <div className="btn-wrap" onClick={e => this.play(e)}>
                                <img src="/images/btn-play.png" alt={'재생'}/>
                            </div>
                        </div>
                    </div>
                );

            // Channel Detail
            case type_channel.detail:
                return (
                    <div className="popup-content">
                        <div className="album" style={{background: this.themeColor}}>
                            <div className="image-wrap">
                                <div className="thumbnail"><img src={this.data.imageProxy} alt={title} onError={this.error}/>
                                </div>
                                <div className="title-box">
                                    <div className="title" dangerouslySetInnerHTML={{__html: title_lined}}></div>
                                    <div className="bg"><img src={this.themeBackground} alt={this.themeName} /></div>
                                </div>
                            </div>
                            <div className="btn-wrap">
                                <ChannelFavorite type={this.type}
                                                 id={this.data.channelid}
                                                 selected={this.data.isFavorite}
                                                 callback={this.favoriteCallback.bind(this)} />
                                <div className="btn-m btn-p1" onClick={e => this.play(e)}>
                                    <img src="/images/icon-play-type2.png" alt="재생하기" />
                                    <span><img src="/images/icon-popup-play.png" alt="재생하기" />재생하기</span>
                                </div>
                            </div>
                        </div>
                        <div className="album-text">
                            <h3>{title}</h3>
                            <div className="hashtag">
                                {
                                    this.theme ?
                                        <div className="item"
                                             onClick={(e) => this.themeClicked(e, this.theme)}>
                                            <span style={{background: this.themeColor}}></span>
                                            {this.themeName}
                                        </div> :
                                        null
                                }
                                {
                                    this.tempo ?
                                        <div className="item">#{this.tempo.proname}</div> :
                                        null
                                }
                                {
                                    this.genre ?
                                        <div className="item">#{this.genre.proname}</div> :
                                        null
                                }
                            </div>
                            <div className="text" dangerouslySetInnerHTML={{__html: this.data.info}}></div>
                            <h4>이 업종에 추천해요!</h4>
                            <div className="recommend">
                                {
                                    this.business.length ?
                                        this.business.map((buisness, index) => {
                                            return <CategoryBusiness key={index} is_mine={false} category={buisness} selected={false} onChange={this.businessClicked.bind(this)} />
                                        }) :
                                        <div className={'item empty'}>추천업종이 없습니다.</div>
                                }
                            </div>
                        </div>
                    </div>
                );

            // 플레이어용 스킨
            case type_channel.player:
                return (
                    <div className="channel-info">
                        <div className="channel-title-wrap">
                            <div className="channel-text">{this.data.headline || '재생중인 채널'}</div>
                            <div className="channel-title" onClick={e => this.clicked(e)}>
                                <div className="title">{title || "채널정보가 없습니다."}</div>
                                <span><img src="/images/icon-player-play.png" alt="상세보기"/></span>
                            </div>
                        </div>
                        <ChannelFavorite type={this.type}
                                         id={this.data.channelid}
                                         selected={this.data.isFavorite}
                                         callback={this.favoriteCallback.bind(this)} />
                    </div>
                );

            // 기본 스킨
            case type_channel.default:
            default:
                return (
                    <div className="result-item" onClick={e => this.clicked(e)}>
                        <div className="image-wrap">
                            {this.data.isNew ? <span className="new">UP</span> : null}
                            <div className="thumbnail"><img src={this.data.imageProxy} alt={title} onError={this.error}/>
                            </div>
                            <div className="title-box">
                                <div className="title" dangerouslySetInnerHTML={{__html: title_lined}}></div>
                                <div className="bg"><img src={this.themeBackground} alt={this.themeName}/></div>
                            </div>
                        </div>
                        <div className="text-wrap">
                            <div className="title">
                                <div className="title-wrap">{title}</div>
                                <div className="btn-wrap">
                                    <ChannelFavorite type={this.type}
                                                     id={this.data.channelid}
                                                     selected={this.data.isFavorite}
                                                     callback={this.favoriteCallback.bind(this)} />
                                    <span onClick={e => this.play(e)}>
                                        <img src="/images/icon-play-type1.png" alt={'재생'}/>
                                    </span>
                                </div>
                            </div>
                            <div className="hashtag">
                            {
                                    this.theme ?
                                        <div className="item"
                                             onClick={(e) => this.themeClicked(e, this.theme)}>
                                            <span style={{background: this.themeColor}}></span>
                                            {this.themeName}
                                        </div> :
                                        null
                                }
                                {
                                    this.tempo ?
                                        <div className="item">#{this.tempo.proname}</div> :
                                        null
                                }
                                {
                                    this.genre ?
                                        <div className="item">#{this.genre.proname}</div> :
                                        null
                                }
                            </div>
                        </div>
                    </div>
                );
        }
    }
}

export default connect()(ChannelItem);


// WEBPACK FOOTER //
// ./src/pages/components/elements/channel.item.jsx